<label class="drop-zone flex-column" [class.file-over]="fileOver" *ngIf="!file">
  <div>
    <i class="{{ dropZoneIconClass }} fs-40 text-primary"></i>
  </div>

  <span class="fs-15" *ngIf="!fileOver">{{ dropPrompt }}</span>
  <span class="fs-15" *ngIf="fileOver">Drop file</span>
  <span class="fs-13 font-weight-light text-muted" *ngIf="showAcceptedFileTypes">({{ acceptedFileTypes }})</span>
  <input type="file" name="myFile" class="drop-zone-input" #fileInput (change)="onFileSelect($event.target.files); $event.target.value = ''" [attr.accept]="acceptedFileTypes" />
</label>
<div class="d-flex align-items-center" *ngIf="file">
  <i class="icon-clip mr-2"></i>
  <div class="mr-auto mr-lg-5">{{ file.name }}</div>
  <a class="text-green cursor-pointer" (click)="deleteFile()">Delete</a>
</div>
